import React from 'react'
import './Home.css'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
function Home() {
  return (
    <div>
      <ToastContainer></ToastContainer>
      <div className='container-h'>
        <div className='word'>
          <h1 className='hd'>Management App</h1>
          <h3  className='hd1'>Class Advisor</h3>
        </div>
      </div>
    </div>
  )
}

export default Home